import React from "react";
import { SkeletonCard, SkeletonChip } from "./SkeletonBox";

/**
 * SearchPageSkeleton - Non-animated skeleton for Search page
 * 
 * Matches layout of:
 * - searchContent.js
 * - searchFilters.js
 */

function skeletonElement(className) {
  return function SkeletonElement(props) {
    var mergedClassName = className + (props.className ? " " + props.className : "");
    return <div {...props} className={mergedClassName} />;
  };
}

var Container = skeletonElement("legacy-skeleton-search");
var SearchInputArea = skeletonElement("legacy-skeleton-search-input-area");
var FilterRow = skeletonElement("legacy-skeleton-wrap-row legacy-skeleton-filter-row");
var FilterItem = skeletonElement("legacy-skeleton-chip-wrap");
var ResultsGrid = skeletonElement("legacy-skeleton-wrap-row legacy-skeleton-results-grid");
var GridItem = skeletonElement("legacy-skeleton-grid-item");
var SearchInputSkeleton = skeletonElement("legacy-skeleton-search-input");

/**
 * Search Input Skeleton
 */
function SearchInputSection() {
  return (
    <SearchInputArea>
      <SearchInputSkeleton />
    </SearchInputArea>
  );
}

/**
 * Filter Chips Row Skeleton
 */
function FilterChipsSkeleton({ count = 4 }) {
  var chips = [];
  var widths = [100, 80, 120, 90];
  
  for (var i = 0; i < count; i++) {
    chips.push(
      <FilterItem key={"filter_" + i}>
        <SkeletonChip width={widths[i % widths.length]} />
      </FilterItem>
    );
  }
  
  return (
    <FilterRow>
      {chips}
    </FilterRow>
  );
}

/**
 * Results Grid Skeleton
 */
function ResultsGridSkeleton({ rows = 3, cols = 4 }) {
  var items = [];
  var total = rows * cols;
  
  for (var i = 0; i < total; i++) {
    items.push(
      <GridItem key={"result_" + i}>
        <SkeletonCard type="portrait" />
      </GridItem>
    );
  }
  
  return (
    <ResultsGrid>
      {items}
    </ResultsGrid>
  );
}

/**
 * SearchPageSkeleton - Main export
 */
function SearchPageSkeleton({ showFilters = true, rows = 3, cols = 4 }) {
  return (
    <Container>
      <SearchInputSection />
      {showFilters && <FilterChipsSkeleton count={4} />}
      <ResultsGridSkeleton rows={rows} cols={cols} />
    </Container>
  );
}

export { SearchInputSection, FilterChipsSkeleton, ResultsGridSkeleton };
export default SearchPageSkeleton;
